import api from './api';

const sensorService = {
  getData: (bridgeId, params) =>
    api.get(`/sensor-data/${bridgeId}`, params),

  getLatest: (bridgeId) =>
    api.get(`/sensor-data/${bridgeId}/latest`),

  getTemperature: (bridgeId, params) =>
    api.get(`/sensor-data/${bridgeId}/temperature`, params),

  getHumidity: (bridgeId, params) =>
    api.get(`/sensor-data/${bridgeId}/humidity`, params),

  download: (bridgeId, params) =>
    api.download(`/sensor-data/${bridgeId}/download`, params),

  upload: (bridgeId, formData) =>
    api.upload(`/sensor-data/${bridgeId}/upload`, formData),

  getAlerts: (bridgeId, params) =>
    api.get(`/alerts/${bridgeId}`, params),

  getUnacknowledged: () =>
    api.get('/alerts/unacknowledged'),

  acknowledgeAlert: (alertId) =>
    api.put(`/alerts/${alertId}/acknowledge`),

  /** Resend email/SMS/voice for a critical threshold alert (admin/owner). */
  resendNotification: (alertId) =>
    api.post(`/alerts/${alertId}/resend-notification`),

  getReport: (bridgeId, params) =>
    api.get(`/reports/${bridgeId}`, params),
};

export default sensorService;
